import Swiper from 'Swiper';
export default function lower_slide(str) {
	const wrapper = $('.slide_wrapper');
	const target = '#js-slide-lower';
	let slide_obj = undefined;
	let slide_num = $(target).find('li').length;

	let options = {
		effect:'fade',
		speed:800,
		slidesPerView: 'auto',
		spaceBetween: 0,
		pagination: '.pagination',
		loop:true,
		autoplay:6000,
		paginationClickable:true
	};

	$(window).on('load',function(){
	  new Swiper(target,options);
	});
};
